import React from "react"
import { connect } from "react-redux"
import { sortBy } from "lodash"
import PropTypes from "prop-types"

import {
  Form, FormGroup, FormControl, ControlLabel,
  ListGroup, ListGroupItem
} from "react-bootstrap"

import CitySelector from "../cities/CitySelector"
import Button from "../components/Button"
import { getText } from "../lib/text"
import { cleanString } from "../../lib/Tools"

import "./ContentSelector.less"

class ContentSelector extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      search: ""
    }
  }

  render() {
    const props = this.props
    const { ActivitiesList, addActivity, selected, language } = props

    const cleanSearchTerm = cleanString(this.state.search)

    return (
      <div className="content-selector">

        <div className="pseudo-form">
          <div>
            <Form inline>
              <CitySelector
                cityId={props.filterCity}
                labelWidth={50}
                onChange={city => props.changeFilterCity(city)}
              />
            </Form>
          </div>

          <div>
            <FormGroup style={{ marginTop: 5 }}>
              <ControlLabel style={{ marginRight: 5 }}>Búsqueda</ControlLabel>
              <FormControl
                value={this.state.search}
                onChange={evt => this.setState({ search: evt.target.value })}
              />
            </FormGroup>
          </div>
        </div>

        <div style={{zIndex: 10, overflowY: props.selected ? "hidden" : "scroll", maxHeight: 470}}>
          <ListGroup style={{ border: "1px solid rgb(51, 122, 183)", marginTop: 8 }} >
            {
              sortBy(
                ActivitiesList
                  .filter(x => (
                    !cleanSearchTerm
                    || cleanString(x.name).includes(cleanSearchTerm)
                    || cleanString(x.title).includes(cleanSearchTerm)
                  )),
                (language == "es" ? "name" : "title")
              )
                .map(a => (
                  <ListGroupItem
                    key={a._id}
                    style={{ position: "relative" }}
                    disabled={a._id == selected}
                  >
                    {
                      (language == "es"
                        ? (a.name || a.title) : (a.title || a.name))
                       || `[${getText("Actividad sin nombre")}]`
                    }
                    <div style={{position: "absolute", right: 25, top: 12}}>
                      <div>
                        <Button
                          bsSize="xsmall"
                          style={{marginRight:10}}
                          onClick={() => addActivity(a)}
                          tooltipText={getText("Añadir")}
                          glyph="plus"
                        />
                        <Button
                          bsSize="xsmall"
                          onClick={() => addActivity(a, "last")}
                          tooltipText={getText("Añadir al final")}
                          glyph="fast-forward"
                        />
                      </div>
                    </div>
                  </ListGroupItem>
                ))
            }
          </ListGroup>
        </div>
      </div>
    )
  }
}

ContentSelector.props = {
  ActivitiesList:   PropTypes.arrayOf(PropTypes.object).isRequired,
  addActivity:      PropTypes.func.isRequired,
  filterCity:       PropTypes.string.isRequired,
  changeFilterCity: PropTypes.func.isRequired,

  selected:         PropTypes.string,
  language:         PropTypes.string,

  Cities:           PropTypes.object.isRequired // { [string]: Object },
}

ContentSelector.defaultProps = {
  selected: null
}

const mapStateToProps = state => ({
  Cities: state.cities
})

export default connect(mapStateToProps)(ContentSelector)
